module.exports = __webpack_public_path__ + "assets/img/icon4-menu2.5efb81f7.svg";